module.exports = __webpack_public_path__ + "static/contact-banner-75dda22bc78c6f2bb1999697493eac63.png";